import { Form, Select, TimePicker } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { PROCESOS_ESPECIFICOS } from 'constants/nombresCatalogos';
import * as fieldMsgs from 'constants/formFieldsMessages';
import dayjs from 'dayjs';
import moment from 'moment';
import './DatosGenerales.scss';
import { useEffect } from 'react';

const format = 'HH:mm';

const DatosGenerales = ({ form, folio }) => {
  const procesosCat = useSelector(selectCatalogByName(PROCESOS_ESPECIFICOS));
  const procesos = procesosCat.map((proceso) => ({
    ...proceso,
    nombreProcesoEspecifico: proceso?.nombreProcesoEspecifico?.replace('Ã±', 'ñ')
  }));

  const handleHour = (_, value) => {
    const Hoy = new Date();
    if (!value) {
      return Promise.reject(new Error(fieldMsgs.ERR_SELECT_FIELD_REQUIRED));
    }
    if (value > Hoy) {
      return Promise.reject(new Error('La hora de apertura no puede ser mayor a la de cierre.'));
    }
    return Promise.resolve();
  };

  const getHourNow = () => {
    const today = moment().format('YYYY-MM-DD HH:mm:ss');
    const now = today.substring(11, 16);
    const hourNow = dayjs(now, format);
    return hourNow;
  };

  useEffect(() => {
    let intervalo;
    if (!folio) {
      intervalo = setInterval(() => {
        form.setFieldsValue({
          horaFinal: getHourNow()
        });
      }, 1000);
    }
    return () => clearInterval(intervalo);
  }, [form, folio]);

  return (
    <div>
      <Form form={form} layout="vertical">
        <div className="container-datosGenerales">
          <Form.Item
            name="procesoEspecificoId"
            label="Proceso:"
            rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
            <Select
              style={{
                width: 200
              }}
              placeholder="Selecciona"
              fieldNames={{
                value: 'idProcesoEspecifico',
                label: 'nombreProcesoEspecifico'
              }}
              options={procesos}
              filterOption={(inputValue, option) =>
                option.nombreProcesoEspecifico?.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                -1
              }
              showSearch
            />
          </Form.Item>
          <Form.Item
            name="horaInicial"
            label="Hora de apertura:"
            rules={[{ validator: handleHour }]}>
            <TimePicker
              style={{
                width: 200
              }}
              format={format}
              inputReadOnly
              allowClear={{
                clearIcon: <ClockCircleOutlined style={{ color: '#c12b7d' }} />
              }}
            />
          </Form.Item>
          <Form.Item
            name="horaFinal"
            label="Hora de cierre:"
            rules={[{ required: true, message: fieldMsgs.ERR_TIME_FIELD_REQUIRED }]}>
            <TimePicker
              style={{
                width: 200
              }}
              disabled
              format={format}
              allowClear={{
                clearIcon: <ClockCircleOutlined style={{ color: '#c12b7d' }} />
              }}
            />
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default DatosGenerales;

DatosGenerales.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func
  }).isRequired,
  folio: PropTypes.string
};

DatosGenerales.defaultProps = {
  folio: null
};
